import { RootStateSocialRewards } from './socialRewardsTypes';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '../types';
import Module from '../interfaces/module.interface';
import { SocialRewardCampaign } from '@/models/social-rewards';
import { ESocialRewards } from '@/views/SocialRewards/SocialRewardsEnum';

export const state: RootStateSocialRewards = new RootStateSocialRewards();

const actions: ActionTree<RootStateSocialRewards, RootState> = {
  SET_SOCIAL_CAMPAIGNS(context, payload: SocialRewardCampaign[]) {
    context.commit('setSocialCampaigns', payload);
  }
};

const mutations: MutationTree<RootStateSocialRewards> = {
  setSocialCampaigns(state, payload: SocialRewardCampaign[]) {
    state.socialRewardCampaign = payload;
    const campaign = payload.find(campaign =>
      [ESocialRewards.FACEBOOK_SHARE, ESocialRewards.TWITTER_SHARE].includes(
        campaign.type
      )
    );
    state.webSiteUrl = campaign && campaign.metadata && campaign.metadata.url;
  }
};

const getters: GetterTree<RootStateSocialRewards, RootState> = {
  getSocialCampaigns(state) {
    return state.socialRewardCampaign || [];
  },
  getCurrentCapaign: state => (type: ESocialRewards) => {
    return (
      state.socialRewardCampaign &&
      state.socialRewardCampaign.find(campaign => campaign.type === type)
    );
  },
  getWebSiteUrl(state) {
    return state.webSiteUrl;
  }
};

const namespaced: boolean = true;

export const socialRewards: Module<RootStateSocialRewards, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters
};
